module.exports = __webpack_public_path__ + "static/media/invoice.d8b844a8.svg";